module.exports = __webpack_public_path__ + "img/yyjjfa_07.c516a84d.jpg";